import I18n from 'I18n';
import { createAction } from 'redux-actions';
import { EMAIL_THREAD_CREATED } from '../constants/actionTypes';
import EmailSentAlert from '../components/EmailSentAlert';
import { jsx as _jsx } from "react/jsx-runtime";
export const emailThreadCreated = createAction(EMAIL_THREAD_CREATED, () => ({}), ({
  threadId
}) => ({
  notification: {
    message: /*#__PURE__*/_jsx(EmailSentAlert, {
      threadId: threadId
    }),
    titleText: I18n.text(`conversations-inbox-ui.alerts.EMAIL_SENT_ALERT.title`),
    type: 'success',
    closeable: true,
    timeout: 3000
  }
}));